import { render, staticRenderFns } from "./motivos.vue?vue&type=template&id=67a67742&"
import script from "./motivos.vue?vue&type=script&lang=js&"
export * from "./motivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports